import {Component, ChangeDetectionStrategy} from '@angular/core';
import {DialogParams} from '../../../../../interfaces/dialog/dialog-params';
import {Dialog} from '../../../../../interfaces/dialog/dialog';
import {DialogService} from '../../../../../services/dialog/dialog.service';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';

import {ConfirmService} from '../../../../../services/confirm/confirm.service';
import {BillingRequest} from '../../../../../models/accounting/billing-request';
import {BillingRequestLineService} from '../../../../../services/accounting/billing-request-line.service';
import {InvoiceLineService} from '../../../../../services/accounting/invoice-line.service';
import {MoneyPipe} from '../../../../../pipes/money/money.pipe';
import {AuthService} from '../../../../../services/auth/auth.service';
import {Config} from '../../../../../models/config';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'app-invoice-update-form',
  templateUrl: './invoice-update-form.component.html',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe
],
  providers: [
    MoneyPipe
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./invoice-update-form.component.scss']
})
export class InvoiceUpdateFormComponent implements Dialog {

  billingLineCategoryList: string[] = [];
  billingRequest!: BillingRequest;

  form: FormGroup = new FormGroup({
    amount: new FormControl(0, Validators.required),
    category: new FormControl('payment', Validators.required),
  });

  constructor(
    private auth: AuthService,
    private dialog: DialogService,
    private billingRequestLineService: BillingRequestLineService,
    private invoiceLineService: InvoiceLineService,
    private confirmService: ConfirmService,
    private moneyPipe: MoneyPipe
  ) {}

  onDialogInit(params: DialogParams): void {
    this.auth.getAsyncConfig().subscribe((config: Config) => {
      this.billingLineCategoryList = config?.data?.billingLineCategoryList ?? [];
    });
    this.billingRequest = params.data;
  }

  getFormattedAmount(): unknown {
    const amount = Number(String(this.form.get('amount')?.value).replace(',', '.')) * 100;
    const billingAmount = this.billingRequest.invoice ?
      this.billingRequest.invoice.currencyTotalAmountTaxIncl :
      this.billingRequest.currencyTotalAmountTaxIncl;
    const totalAmount = billingAmount + amount;
    const currency = this.billingRequest.paymentCurrency?.isoCode;

    return this.moneyPipe.transform(totalAmount, 2, currency);
  }

  getReference(): string {
    return (this.billingRequest.invoice && this.billingRequest.invoice.reference) ?
      this.billingRequest.invoice.reference :
      'deferred';
  }

  submit(): void {
    const data: any = {
      amount: this.getAmount(),
      category: String(this.form.get('category')?.value)
    };

    if (this.billingRequest.invoice) {
      data.invoiceId = this.billingRequest.invoice.id;

      this.invoiceLineService.create(data).subscribe(() => {
        this.dialog.closeDialog(true);
      });
    } else {
      data.billingRequestId = this.billingRequest.id;

      this.billingRequestLineService.create(data).subscribe(() => {
        this.dialog.closeDialog(true);
      });
    }
  }

  close(): void {
    this.dialog.closeDialog(false);
  }

  private getAmount(): number {
    return Number(String(this.form.get('amount')?.value).replace(',', '.')) * 100;
  }

}
